import React from 'react';
import "./TournamentHistory.css"
import FeedPagination from './tournamentFeedPagination';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import moment from 'moment';
import i18next from 'i18next'

class TournamentHistoryTable extends React.Component {
    constructor(props) {
        super(props);
    }
    toggleOpenDetails = (uniqueId) => {
        this.props.toggleTournamentHistoryDetails(!this.props.tournamentHistoryFlag)
    }
    render() {
        return (
            <div>
                {
                    this.props.tournamentFeed.length > 0
                        ?
                        <div>
                            {this.props.tournamentFeed.map((feed) => {
                                // let tournyDtls = feed.tournyDtls[0]
                                return (
                                    <div>
                                        <MediaQuery minWidth={951} >
                                            <div className={"border-bottom-tournamnet tournament-table-row"}>
                                                <div style={{ paddingLeft: 0 }} className="col-md-4 col-xs-4">{feed.tournamentName}</div>
                                                <div style={{ padding: 0 }} className="col-md-1 col-xs-1">${feed.totalBuyin}</div>
                                                <div style={{ padding: 0, width: "11.666667%" }} className="col-md-2 col-xs-2"> {moment(feed.startTime.value).utc().format("D MMM hh:mm")}</div>
                                                <div style={{ padding: 0 }} className="col-md-1 col-xs-1">${feed.totalfee}</div>
                                                <div style={{ padding: 0, width: "11.666667%" }} className="col-md-2 col-xs-2 ">${feed.totalBountyPrize}</div>
                                                <div style={{ padding: 0, width: "11.666667%" }} className="col-md-2 col-xs-2">${feed.totalMainPrize}</div>
                                                <div style={{ padding: 0 }} className="col-md-1 col-xs-1">${feed.totalWon}</div>
                                            </div>
                                        </MediaQuery>
                                        <MediaQuery minWidth={731} maxWidth={950} >
                                            <div className={"border-bottom-tournamnet tournament-table-row"}>
                                                <div style={{ paddingLeft: 0 }} className="col-xs-12 tournament-font-bold" >{feed.tournamentName}</div>
                                                <div style={{ padding: 0 }} className="col-xs-12" >{i18next.t("lable.buyIn")}: ${feed.totalBuyin} - {i18next.t("lable.startDate")}: {moment(feed.startTime.value).utc().format("D MMM hh:mm")} - {i18next.t("lable.fees")}: ${feed.totalfee}
                                                </div>
                                                <div style={{ padding: 0 }} className="col-xs-12" >{i18next.t("lable.prizeWon")}: ${feed.totalMainPrize} - {i18next.t("lable.totalPrizes")}: ${feed.totalWon}</div>
                                            </div>
                                        </MediaQuery>

                                        <MediaQuery maxWidth={730} >
                                            <div className={"border-bottom-tournamnet tournament-table-row"}>
                                                <div style={{ paddingLeft: 0 }} className="col-xs-12 tournament-font-bold" >{feed.tournamentName}</div>
                                                <div style={{ padding: 0 }} className="col-xs-12" >{i18next.t("lable.buyIn")}: ${feed.totalBuyin} - {i18next.t("lable.startDate")}: {moment(feed.startTime.value).utc().format("D MMM hh:mm")} - {i18next.t("lable.fees")}: ${feed.totalfee}
                                                </div>
                                                <div style={{ padding: 0 }} className="col-xs-12" >{i18next.t("lable.bountiesWon")}:{feed.totalBountyPrize}</div>
                                                <div style={{ padding: 0 }} className="col-xs-12" >{i18next.t("lable.prizeWon")}: ${feed.totalMainPrize}</div>
                                                <div style={{ padding: 0 }} className="col-xs-12" >{i18next.t("lable.totalPrizes")}: ${feed.totalWon}</div>
                                            </div>
                                        </MediaQuery>
                                    </div>
                                )
                            })}
                            <center>
                                <FeedPagination
                                    pageNumber={this.props.pageNumber}
                                    tournyPlayed={this.props.tournamentAggResult.tournyPlayed}
                                    nextPage={this.props.nextPage}
                                    isMobileView={false}
                                    loading={this.props.loading}
                                    isFullScreen={this.props.isFullScreen} />
                            </center>

                        </div>
                        : <center> <h3 style={{ padding: '30px' }}>{i18next.t("lable.noDataFoundcngfilter")}</h3></center>
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        tournamentHistoryFlag: state.multipleReportCards.tournamentHistoryFlag,
        lang: state.header.lang
    };
};

const mapDispatchToProps = dispatch => {
    return {
        toggleTournamentHistoryDetails: (data) => dispatch(actions.toggleTournamentHistoryDetails(data))
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(TournamentHistoryTable);



/** WEBPACK FOOTER **
 ** ./src/components/MyStatistics/TournamentHistoryTable.js
 **/